import i18next from 'i18next';
import React from 'react';
import { authOptions } from 'site/rootWidget';
import { routeUpdaters } from 'site/routes/routesState';
import { SubscriptionState, subscriptionUpdaters } from 'subscription/subscriptionState';
import { ButtonPrimary } from 'utils/buttons';
import { DataLayer } from 'utils/datalayer';
import { AuthButtonPrimary, formSkeletonConfig, FormSkeletonLayout } from 'utils/forms';
import { getClassName } from 'utils/utils';
import { Updater } from 'widgets-for-react/dist/widgets-main';

interface UpdatePaymentLayoutProps {
    isLoggedIn: boolean;
    setState: (_: Updater<SubscriptionState>) => void;
}

export const UpdatePaymentLayout = ({ isLoggedIn, setState }: UpdatePaymentLayoutProps) => {

    const title = i18next.language === "en" ? "Action required: choose a new payment method now" : "Actie vereist: kies nu een nieuwe betaalmethode";
    const introText = i18next.language === "en" ? 
        "At Gastronomixs, we are constantly working to improve our service. That is why we are switching to a new payment system. Unfortunately, this also means that we will be discontinuing PayPal mainly due to high transaction costs and technical limitations. We therefore ask you to update your payment method now." :
        "Bij Gastronomixs werken we continu aan het verbeteren van onze service. Daarom stappen we over op een nieuw betaalsysteem. Helaas stoppen we dan ook met PayPal, vanwege hoge transactiekosten en technische beperkingen. Daarom vragen we je om nu je betaalmethode aan te passen."
    
    const introLoggedInButtonText = i18next.language === "en" ? "Please click on the button below and follow the steps." : "Klik op de button hieronder en volg de stappen.";
    const introLoggedOutButtonText = i18next.language === "en" ? "Please click on the button below, log in and follow the steps." : "Klik op de button hieronder, log in en volg de stappen.";

    const buttonLoggedInText = i18next.language === "en" ? "Update your payment method" : "Betaalmethode aanpassen";

    return <FormSkeletonLayout type="trial-to-pro-success" kind="text-image" options={authOptions} isClrInverted={true} image={formSkeletonConfig.imageDark}>
        <header className={getClassName(authOptions, 'headerClassName', 'mb-4')}>
            <h1 className={getClassName(authOptions, 'titleClassName', 'mb-4')}>{title}</h1>
            <p className={getClassName(authOptions, 'introClassName', 'lead')}>{introText}</p>
            <p className={getClassName(authOptions, 'introClassName')}>{isLoggedIn ? introLoggedInButtonText : introLoggedOutButtonText}</p>
            <div style={{marginTop: '8px'}}>
                {isLoggedIn && <AuthButtonPrimary
                    kind="button"
                    type="button"
                    onClick={() => setState(subscriptionUpdaters.startSubscriptionUpdatePaymentMethodPortalSession())}
                    label={buttonLoggedInText}
                    />
                }
                {!isLoggedIn &&         
                    <ButtonPrimary
                    kind="link"
                    to={
                        routeUpdaters(i18next.language).login.url +
                        `?originPath=${window.location.pathname}`
                    }
                    onClick={() => {
                        DataLayer.headerButtonsClick(i18next.t('auth:loginHeader'))
                    }}
                    size="s"
                    label={i18next.t('auth:loginHeader')}
                    />
                }
            </div>
        </header>
    </FormSkeletonLayout>
}